module.exports = __webpack_public_path__ + "15ada91f29411e0452dd2fd5a6176b47.jpg";